import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

  // Evento de callback 
  @Output() onClick = new EventEmitter<any>();

  //texto do botão
  @Input() textButton: string;

  //habilitado btn
  @Input() enable: boolean;

  //style do btn, branco ou vermelho
  //secundary branco
  //primary vermelho
  @Input() styleButton: string;

  // Largura do botao
  @Input() minWidth: string = "auto";

  clickEvent(){
    this.onClick.emit()
  }

}
